import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../../../context/auth-context'
import { LoadingAndErrors } from '../../../../../components/custom_components/LoadingAndErrors'
import { EmployeeObjectives } from './EmployeeObjectives'
import { MeetingStepDefaultProps } from '../../shared/appraisal-types'
import MeetingBackground from '../../../../../components/custom_components/Meeting/MeetingBackground'
import AppraisalPageDescription from '../../shared/AppraisalPageDescription'
import PerFlexRow from '../../../../../components/custom_components/FlexRow'
import { ClosedTargetsComponent } from '../../../okr/closedTargets/ClosedTargetsComponent'
import { MeetingStepStatus, MeetingStepViewId, ObjectivesInMeetingQuery } from '../../../../../types'
import { AppraisalFlowHelper } from '../../shared/AppraisalFlowHelper'
import useObjectivesInMeeting from '../../../../../graphql/objectives/useObjectivesInMeeting'
import { useTargetsModalStore } from '../../../../../components/custom_components/TargetsModal/TargetsModalStore'
import shallow from 'zustand/shallow'

interface EmployeeMeetingStepDevelopmentContentProps {
  data: ObjectivesInMeetingQuery
}

const EmployeeMeetingStepDevelopment: FC<MeetingStepDefaultProps> = ({ backBtn, nextBtn, meeting }) => {
  const { loading, error, data } = useObjectivesInMeeting(meeting.id)

  if (loading || error || !data || !data.objectivesInMeeting) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.objectivesInMeeting} error={error} />
  } else {
    return <EmployeeMeetingStepDevelopmentContent meeting={meeting} data={data} backBtn={backBtn} nextBtn={nextBtn} />
  }
}

const EmployeeMeetingStepDevelopmentContent: FC<MeetingStepDefaultProps & EmployeeMeetingStepDevelopmentContentProps> = ({
  meeting,
  data,
  backBtn,
  nextBtn,
}) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const [setModalProps, cleanModalProps] = useTargetsModalStore((state) => [state.setModalProps, state.cleanModalProps], shallow)

  const objectives = data.objectivesInMeeting

  useEffect(() => {
    setModalProps({ meetingId: meeting.id, employeeId: user.employeeId, meeting })
    return () => {
      cleanModalProps()
    }
  }, [meeting, user.employeeId, setModalProps, cleanModalProps])

  return (
    <div data-e2e-employee-meeting-step-development>
      <MeetingBackground>
        <AppraisalPageDescription description={t('appraisalMeeting.stepDevelopmentAndTargets.pageDescriptionEmployee')} />
        <EmployeeObjectives employeeId={user.employeeId} meeting={meeting} objectives={objectives} />
        <ClosedTargetsComponent objectives={objectives} />
      </MeetingBackground>
      <PerFlexRow justify="space-between">
        {backBtn && backBtn()}
        {nextBtn && nextBtn(MeetingStepStatus.Done)}
      </PerFlexRow>
      <AppraisalFlowHelper stepViewId={MeetingStepViewId.DevelopmentAndTargets} stepStatus={MeetingStepStatus.Done} />
    </div>
  )
}

export default EmployeeMeetingStepDevelopment
